import {IBienLaiSelectByThiSinhRequest} from "../../../model/request/bien-lai/IBienLaiSelectByThiSinhRequest";
import {IBienLaiThuViewModel} from "../../../model/respone/bien-lai/IBienLaiThu";
import {generateActionTypeIds} from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export interface IBienLaiViewTuyenSinhBaseActionTypes<T> {
    request: IBienLaiSelectByThiSinhRequest;
    data: T;
}

export const eBienLaiViewTuyenSinhActionsObj = {
    LOAD_START: {} as IBienLaiSelectByThiSinhRequest,
    LOAD_SUCCESS: {} as IBienLaiViewTuyenSinhBaseActionTypes<
        IBienLaiThuViewModel[]
    >,
    LOAD_ERRR: {} as IBienLaiViewTuyenSinhBaseActionTypes<string>,
};
export const eBienLaiViewTuyenSinhActionTypeIds = generateActionTypeIds(
    eBienLaiViewTuyenSinhActionsObj,
    "BIEN_LAI_VIEW_TUYEN_SINH"
);
export type IBienLaiViewTuyenSinhActionTypes = IGenericActionType<
    typeof eBienLaiViewTuyenSinhActionsObj,
    "BIEN_LAI_VIEW_TUYEN_SINH"
>;
